import styled from "styled-components/macro";
import {DatePickerContainer} from "../../ui/FormDatePicker/FormDatePicker";
import {WindowSizePXEnum} from "../../interface/Basic/window";
import {ModalInfoDiscription} from "../Font";
import {WarningModalActiveBtn} from "./Button";
import {FlexColumnCenteredProps} from "./Content";

export const ModalContent = styled.div`
  position: relative;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  background-color: ${({theme}) => theme.color.primaryBackground};
  outline: 0;
  width: 500px;
  height: auto;
  @media (max-width: ${WindowSizePXEnum.md}) {
    align-self: center;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
    overflow: hidden;
    box-shadow: none;
    min-width: unset;
    justify-content: flex-start;
    border-radius: 0;
    padding: 68px 0;
    position: absolute;
    top: 0;
    height: 100vh;
    overflow-y: auto;
  }
`
export const EditAvatarModalContent = styled(ModalContent)`
  display: flex;
  align-self: center;
  width: 400px;
  min-height: 400px;
  flex-direction: column;
  justify-content: space-between;
  margin: 8% auto;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    position: fixed;
    padding-top: 88px;
    width: 100%;
    margin: 0;
    justify-content: flex-start;
    .avatar-footer{
      justify-content: center;
    }
  }

`
export const AvatarSvgContent = styled.div`
  width: 100px;

  :hover {
    cursor: pointer;
  }
`

export const AvatarImg = styled.img`
  width: 400px;
`
export const AvatarModal = styled.div`
  position: absolute;
  top: 100px;
  left: calc(50% - 858px / 2 + 495.5px);
  z-index: 100;
  @media (max-width: ${WindowSizePXEnum.md}) {
    left: calc(50% - 798px / 2 + 495.5px);
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    left: 8px;
    top: unset;
    bottom: 10px;
    width: calc(100vw - 16px);
  }
`
export const AvatarModalContent = styled.div`
  position: absolute;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  background-color: ${({theme}) => theme.color.primaryBackground};
  outline: 0;
  width: 179px;
  height: 88px;
  font-weight: 300;
  font-size: 12px;
  padding: 16px;
  right: 265px;
  top: 94px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    top: -90px;
    left: 0px;
    width: calc(100vw - 16px);
  }
`

export const AvatarAddModalContent = styled(AvatarModalContent)`
  height: 44px;
  justify-content: center;
`

export const WarningModalBackground = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    position: absolute;
    background-color: ${({theme}) => theme.color.primaryBackground};
  }

`

export const WarningModalContent = styled(ModalContent)`
  margin: 15% auto;
  border: 1px solid #888;
  overflow: hidden;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0px;
    left: 0px;
    margin: unset;
    border: none;
  }
`

export const ExAccModalContent = styled(ModalContent)`
  margin: 15% auto;
  border: 1px solid #888;
  overflow: hidden;
  width: 380px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0px;
    left: 0px;
    margin: unset;
    border: none;
  }
`
export const ModalHeader = styled.div`
  display: flex;
  padding: 24px 24px 0 24px;
`

export const AvatarModalHeader = styled(ModalHeader)`
  align-self: center;
  padding-top: 0px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: 88px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column-reverse;
    padding-left: 16px;
  }
`

export const InfoModalHeader = styled(ModalHeader)`
  justify-content: space-between;
  font-weight: 700;
  line-height: 28px;
  align-items: center;

  .modalDots {
    padding-right: 8px;
  }
}

@media (max-width: ${WindowSizePXEnum.xs}) {
  .modalDots {
    margin-top: 25px;
  }

`
export const ModalTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 19px;
  margin: auto 0;
`
export const ModalClose = styled.div`
  margin-left: auto;
  cursor: pointer;
  color: rgba(51, 51, 51, 0.5);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  :hover {
    background-color: ${({theme}) => theme.color.secondaryBackground};
  }
`
export const ModalBody = styled.div`
  //max-height: 70vh;
  //overflow-y: scroll;
  padding: 24px 24px 0 24px;

  input {
    padding: 8px;
    height: 40px;
  }

  textarea {
    padding: 8px;
    height: 60px;
    resize: none;
    width: 100%;
  }

  ${DatePickerContainer} {
    margin: 0;
    height: 40px;
  }

  @media (max-width: ${WindowSizePXEnum.md}) {
    ${ModalInfoDiscription} {
      max-width: 185px;
    }
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    ${ModalInfoDiscription} {
      max-width: 80px;
    }
  }
`

export const AvatarModalBody = styled(ModalBody)`
  display: flex;
  justify-content: center;
  align-self: center;
  width: 400px;
  padding: 0px;
  .ReactCrop{
    max-height: 320px;
  }
  @media(max-width: ${WindowSizePXEnum.xs}){
    width: 100%;
  }
  
`

export const ModalFooter = styled.div`
  background-color: ${({theme}) => theme.color.primaryBackground};;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 5px;
  bottom: 0;
  justify-content: flex-end;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    .avatar-def-btn {
      display: none;
    }

    .avatar-active-btn {
      width: 100%;
      height: 56px;
      max-width: 280px;
      justify-content: center;
    }
  }
`

export const ModalFooterCenter = styled.div`
  background-color: ${({theme}) => theme.color.primaryBackground};;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 5px;
  bottom: 0;
  justify-content: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

export const AvatarModalBackground = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`
export const InfoModalTitle = styled(ModalTitle)`
  font-weight: 700;
  line-height: 28px;
`

export const EditSvg = styled.svg`
  margin-right: 12px;
`

export const HeaderDropDownContent = styled.div`
  display: flex;
  padding: 0px;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 113px;
  height: 60px;
  left: -10px;
  top: 50px;
  background: #FFFFFF;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08), 0px 2px 24px rgba(0, 0, 0, 0.08);
  border-radius: 10px;

`

export const HeaderDropDownModal = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 14px;
`

export const ModalsInfoContent = styled.div`
  padding: 0px 24px 24px 24px;
  position: relative;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  background-color: ${({theme}) => theme.color.primaryBackground};
  outline: 0;
  width: 500px;
  height: auto;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
    height: 100%;
    position: fixed;
    border-radius: 0px;
  }
`

export const ModalsEditMenu = styled(AvatarModalContent)`
  left: calc(50% - 113px / 2 + 65.5px);
  top: 145px;
  z-index: 100;
  @media (max-width: ${WindowSizePXEnum.md}) {
    left: calc(50% - 10px / 2 + 65.5px);
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    left: 20px;
    top: unset;
    bottom: 10px;
    width: calc(100vw - 40px);
  }
`
export const ModalsEditMenuBackground = styled.div`
  display: none;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: unset;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }
`
export const ProfileModalsEditMenu = styled(AvatarModalContent)`
  top: 155px;
  z-index: 10;
  left: calc(50% - 110px / 2 + 65.5px);
  @media (max-width: ${WindowSizePXEnum.md}) {
    left: calc(50% - 25px / 2 + 65.5px);
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    position: absolute;
    top: unset;
    bottom: 20px;
    left: 12px;
    margin: 0 auto;
    width: 92%;
    z-index: 100;
  }
`

export const MobileBackground = styled.div`
  display: none;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: unset;
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }
`

export const LangDropDownContent = styled(HeaderDropDownContent)`
  left: 0;
  top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  height: unset;
`

export const ModalsWarningBackground = styled.div`
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;

  .modals-warning {
    top: 50px;
    justify-content: space-between;
    ${ModalFooter} {
      padding: 12px;
      @media(max-width: ${WindowSizePXEnum.xs}){
        margin-bottom: 16px;
      }
    }
  }

  @media (max-width: ${WindowSizePXEnum.md}) {
    .modals-warning {
      top: 15%;
    }
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    .modals-warning {
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      top: 200px;
      padding: 0 0;
      height: 152px;
      width: 280px;
      border-radius: 10px;

      ${ModalHeader} {
        padding-top: 19px;
      }

      ${ModalTitle} {
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 22px;
        margin-bottom: -16px;
      }

      ${ModalFooter} {
        justify-content: space-around;

        ${WarningModalActiveBtn} {
          background-color: ${({theme}) => theme.color.primaryBackground};
          color: ${({theme}) => theme.color.indicator};
        }
      }
    }
  }

`

export const ConfirmModalWrapper = styled.div<FlexColumnCenteredProps>`
  position: fixed;
  z-index:9999;

  /* фиксированное положение */
  inset: 0;
  background: rgb(0 0 0 / 38%);


  /* по умолчанию модальное окно прозрачно */
  display: flex;
  transition: all .3s ease-out;
`
export const ConfirmModalContainer = styled.div<FlexColumnCenteredProps>`
  width:400px;
  min-height: 250px;
  background:rgb(255,255,255);
  border-radius: 10px;
  padding: 24px;
  margin: auto;
  @media (max-width: ${WindowSizePXEnum.xxs}) {
    margin: auto 16px;
  }
`
